import React from 'react'
import { Card, Col, Progress, Row, Statistic, Tooltip } from 'antd'
import { ArrowUpOutlined, DollarOutlined, FileTextOutlined, WalletOutlined } from '@ant-design/icons'
import dashboardStyles from '../styles/dashboardStyles'
import { formatCurrency } from '../utils'

const FinancialSummary = ({ financialSummary = {} }) => {
  const { totalRevenue = 0, outstandingInvoices = 0, pendingClaims = 0, collectionRate = 0 } = financialSummary

  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} sm={12} md={6}>
        <Card style={dashboardStyles.statisticCard}>
          <Statistic
            title='Total Revenue (MTD)'
            value={totalRevenue}
            formatter={(value) => formatCurrency(value)}
            valueStyle={{ color: '#3f8600' }}
            prefix={<DollarOutlined />}
            suffix={
              <Tooltip title='8.2% increase from last month'>
                <span style={{ fontSize: '14px', marginLeft: '8px' }}>
                  <ArrowUpOutlined /> 8.2%
                </span>
              </Tooltip>
            }
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card style={dashboardStyles.statisticCard}>
          <Statistic
            title='Outstanding Invoices'
            value={outstandingInvoices}
            formatter={(value) => formatCurrency(value)}
            valueStyle={{ color: '#cf1322' }}
            prefix={<DollarOutlined />}
            suffix={
              <Tooltip title='3.1% increase from last month'>
                <span style={{ fontSize: '14px', marginLeft: '8px' }}>
                  <ArrowUpOutlined style={{ color: '#cf1322' }} /> 3.1%
                </span>
              </Tooltip>
            }
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card style={dashboardStyles.statisticCard}>
          <Statistic
            title='Pending Claims'
            value={pendingClaims}
            valueStyle={{ color: '#1890ff' }}
            prefix={<FileTextOutlined />}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card style={dashboardStyles.statisticCard}>
          <Statistic
            title='Collection Rate'
            value={collectionRate}
            precision={1}
            valueStyle={{ color: '#3f8600' }}
            suffix='%'
            prefix={<WalletOutlined />}
          />
          <Progress percent={collectionRate} showInfo={false} strokeColor='#3f8600' />
        </Card>
      </Col>
    </Row>
  )
}

export default FinancialSummary
